import { combineReducers } from 'redux'
import { authReducer } from "./user/auth/reducers";

export default combineReducers({
    auth: authReducer,
})